// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResourceCard_wrapper__g0_Np","title":"ResourceCard_title__Rnm5c","text":"ResourceCard_text__a31py","resourceIcon":"ResourceCard_resourceIcon__4ARWF"};